module.exports = __webpack_public_path__ + "static/media/work.848ea117.jpg";